import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { MonitoringOnboardingPage } from '@/areas/market-insights/MarketInsights/pages/MonitoringOnboardingPage';
import type { PageStaticData } from '@/shared/routing';

// The monitoring layout (`monitoring/route.tsx`) checks who may open this page.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/onboarding')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <MonitoringOnboardingPage />;
}
